import { css } from "@emotion/css";

import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";
import { fade } from "@/modules/theme/utils/fade";

import activeLinkMarkSrc from "./icons/active-link-mark.svg";
import dashboardActiveIconSrc from "./icons/dashboard-active-icon.svg";
import dashboardIconSrc from "./icons/dashboard-icon.svg";
import handbookActiveIconSrc from "./icons/handbook-active-icon.svg";
import handbookIconSrc from "./icons/handbook-icon.svg";
import levelsActiveIconSrc from "./icons/levels-active-icon.svg";
import levelsIconSrc from "./icons/levels-icon.svg";
import moreActiveIconSrc from "./icons/more-active-icon.svg";
import moreIconSrc from "./icons/more-icon.svg";
import tasksActiveIconSrc from "./icons/tasks-active-icon.svg";
import tasksIconSrc from "./icons/tasks-icon.svg";
import tutorialsActiveIconSrc from "./icons/tutorials-active-icon.svg";
import tutorialsIconSrc from "./icons/tutorials-icon.svg";

export const createNavMenuStyles = ({
  spacing,
  palette,
  typography,
  boxShadows,
  zIndexes,
  borderRadius,
}: Theme) => ({
  root: css({
    position: "fixed",
    boxShadow: boxShadows.navMenu,
    backgroundColor: fade(white, 0.9),
    color: palette.default.text,
    zIndex: zIndexes.navMenu,
    bottom: spacing(2),
    left: spacing(2),
    right: spacing(2),
    borderRadius: borderRadius.navMenu,
    padding: spacing([0, 2]),

    "@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))": {
      backdropFilter: "blur(20px)",
      backgroundColor: fade(white, 0.8),
    },
  }),
  navigationList: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  navigationLink: css({
    textDecoration: "none",
    fontSize: typography.pxToRem(9),
    color: grey[500],
    fontWeight: typography.fontWeight.medium,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: spacing([1.5, 1, 2]),
    "&:before": {
      content: "''",
      width: "22px",
      height: "22px",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      marginBottom: spacing(1),
    },
  }),
  linkActive: css({
    position: "relative",
    fontWeight: typography.fontWeight.semiBold,
    color: grey[800],
    "&:after": {
      content: "''",
      width: 46,
      height: 22,
      position: "absolute",
      backgroundImage: `url(${activeLinkMarkSrc})`,
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  }),
  handbook: css({
    "&:before": {
      backgroundImage: `url(${handbookIconSrc})`,
    },
  }),
  handbookActive: css({
    "&:before": {
      backgroundImage: `url(${handbookActiveIconSrc})`,
    },
  }),
  levels: css({
    "&:before": {
      backgroundImage: `url(${levelsIconSrc})`,
    },
  }),
  levelsActive: css({
    "&:before": {
      backgroundImage: `url(${levelsActiveIconSrc})`,
    },
  }),
  tasks: css({
    "&:before": {
      backgroundImage: `url(${tasksIconSrc})`,
    },
  }),
  tasksActive: css({
    "&:before": {
      backgroundImage: `url(${tasksActiveIconSrc})`,
    },
  }),
  tutorials: css({
    "&:before": {
      backgroundImage: `url(${tutorialsIconSrc})`,
    },
  }),
  tutorialsActive: css({
    "&:before": {
      backgroundImage: `url(${tutorialsActiveIconSrc})`,
    },
  }),
  more: css({
    "&:before": {
      backgroundImage: `url(${moreIconSrc})`,
    },
  }),
  moreActive: css({
    "&:before": {
      backgroundImage: `url(${moreActiveIconSrc})`,
    },
  }),
  dashboard: css({
    "&:before": {
      backgroundImage: `url(${dashboardIconSrc})`,
    },
  }),
  dashboardActive: css({
    "&:before": {
      backgroundImage: `url(${dashboardActiveIconSrc})`,
    },
  }),
});
